module.exports = __webpack_public_path__ + "static/images/lpk.4bb4670.png";